import { Typography, TypographyProps, styled } from '@mui/material';

export const WrappedTypography = styled(Typography)<TypographyProps>(() => ({
  overflowWrap: 'break-word',
  hyphens: 'auto',
}));
